import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

// Solo formato básico: sin colores, fuentes, tamaños, enlaces, imágenes ni video.
// `formats` también filtra lo que se pega desde Word u otras páginas.
const TOOLBAR = [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean'],
]

const FORMATS = ['bold', 'italic', 'underline', 'list', 'bullet']

const MODULES = {
    toolbar: TOOLBAR,
    clipboard: { matchVisual: false },
}

export default function BasicRichTextEditor({ value, onChange, placeholder, isInvalid = false, minHeight = 280 }) {
    return (
        <div className={'basic-rich-text-editor' + (isInvalid ? ' is-invalid' : '')}>
            <ReactQuill
                theme="snow"
                value={value || ''}
                onChange={(html, _delta, _source, editor) => onChange(editor.getText().trim() === '' ? '' : html)}
                modules={MODULES}
                formats={FORMATS}
                placeholder={placeholder}
            />
            <style jsx="true">{`
                .basic-rich-text-editor .ql-toolbar.ql-snow {
                    border-radius: 0.475rem 0.475rem 0 0;
                    border-color: var(--bs-gray-300, #e4e6ef);
                }
                .basic-rich-text-editor .ql-container.ql-snow {
                    border-radius: 0 0 0.475rem 0.475rem;
                    border-color: var(--bs-gray-300, #e4e6ef);
                    font-family: inherit;
                    font-size: 1rem;
                }
                .basic-rich-text-editor .ql-editor {
                    min-height: ${minHeight}px;
                }
                .basic-rich-text-editor.is-invalid .ql-toolbar.ql-snow,
                .basic-rich-text-editor.is-invalid .ql-container.ql-snow {
                    border-color: var(--bs-danger, #f1416c);
                }
            `}</style>
        </div>
    )
}
